import PopupFormUploadMedia from './PopupFormUploadMedia.container';

export default PopupFormUploadMedia;
